<template>
  <div>
    <nav class="mb-4">
      <div class="container">
        <div class="compact-nav">
          <a class="btn btn-icon btn-lg menu-btn" :href="'/'+base+'/'+sitedata.websiteid"><span class="ico material-icons">arrow_back</span></a>
          <button v-if="!readonly" class="btn btn-link ml-auto" @click.prevent="showModal = true">VERWIJDEREN</button>
        </div>
        <div class="page-header">
          <h1 class="title">
            <inline-editor v-if="!readonly" :editable="mainpage.pagetitle" :pageid="mainpage._id" dbentry="pagetitle" element="normal"/>
            <span v-else>{{mainpage.pagetitle}}</span>
          </h1>
          <p class="text-muted"><inline-editor v-if="!readonly" :editable="mainpage.pagetext" :pageid="mainpage._id" dbentry="pagetext" element="textarea"/></p>
        </div>
      </div>
    </nav>
    <div class="container">
      <div class="well" v-for="(block, index) in orderedPages" :id="block.pageslug" :class="{'well-image': block.blockstyle == 'image'}">
        <button v-if="!readonly" class="btn btn-icon edit-block" @click.prevent="editMenu(block._id)"><span class="ico material-icons">more_vert</span></button>
        <h2 class="well-title">
          <inline-editor v-if="!readonly" :editable="block.pagetitle" :pageid="block._id" dbentry="pagetitle" element="normal"/>
          <span v-else>{{block.pagetitle}}</span>
        </h2>
        <div class="content text-muted">
          <inline-editor v-if="!readonly" :editable="block.pagetext" :pageid="block._id" dbentry="pagetext" element="textarea"/>
          <span v-else>{{block.pagetext}}</span>
        </div>
        <div v-if="block.blockstyle == 'doc'" class="mt-2">
          <div class="addblock" v-if="!block.blockimage">
            <upload-modal @clicked="uploadDoc" :pageid="block._id" :websiteid="websiteid" returnvalue="true" thestyle="btn btn-outline-secondary"><span class="ico material-icons">cloud_upload</span> Document uploaden</upload-modal>
          </div>
          <div v-else>
            <a target="_blank" :href="block.blockimage" class="btn btn-primary mr-2"><span class="ico material-icons">description</span> Bekijk document</a>
            <upload-modal v-if="!readonly" @clicked="uploadDoc" :pageid="block._id" :websiteid="websiteid" returnvalue="true" thestyle="btn btn-outline-secondary">Andere uploaden</upload-modal>
          </div>
        </div>
        <div v-if="block.blockstyle == 'image'" class="mt-2">
          <div class="addblock" v-if="!block.blockimage">
            <upload-modal @clicked="uploadDoc" :pageid="block._id" :websiteid="websiteid" returnvalue="true" thestyle="btn btn-outline-secondary"><span class="ico material-icons">image</span> Afbeelding uploaden</upload-modal>
          </div>
          <div v-else class="img-container">
            <img :src="block.blockimage" alt="" />
            <upload-modal v-if="!readonly" @clicked="uploadDoc" :pageid="block._id" :websiteid="websiteid" returnvalue="true" thestyle="btn btn-on-image img-upload">Andere uploaden</upload-modal>
          </div>
        </div>
      </div>
      
      <!--a class="btn btn-primary btn-lg btn-block" :href="'#'">AFRONDEN & VERDER <span class="ico material-icons">arrow_forward</span></a-->
      <!-- add a page -->
      <page-adder :websiteid="websiteid" v-if="!readonly" :parentpageid="mainpageid" @clicked="getPages" class="mb-4"/>
    </div>

    <modal v-if="showModal" @close="showModal = false" title="Stap verwijderen">
        <form @submit.prevent="removePage(mainpage._id)">
            <p>Weet je het zeker?</p>
            <p  class="alert error">Hiermee verwijder je ook alle voortgang van studenten.</p>
            <button class="btn btn-outline-secondary" type="submit">Ja, ik weet het zeker</button>
        </form>
    </modal>

    <modal v-if="editModal" @close="editModal = false" title="Verwijderen">
        <form @submit.prevent="removeBlock(editid)">
            <p>Weet je zeker dat je dit blok wil verwijderen?</p>
            <button class="btn btn-outline-secondary" type="submit">Ja, ik weet het zeker</button>
        </form>
    </modal>
  </div>
</template>

<script>
  import InputDefault from '../components/form/InputDefault.vue';
  import AlertBar from '../components/form/Alert.vue';
  import Loader from '../components/ui/Loader.vue';
  import MainNav from '../components/navigation/MainNav.vue';
  import Modal from '../components/modal/Modal.vue';
  import MainFooter from '../components/navigation/MainFooter.vue';
  import SectionBlock from '../components/content/SectionBlock.vue';
  import ItemAdder from '../components/app/ItemAdder.vue';
  import PageAdder from '../components/app/PageAdder.vue';
  import Home from './Home.vue';
  import InlineEditor from '../components/app/InlineEditor.vue';
  import UploadModal from '../components/modal/UploadModal.vue';

  import axios from 'axios';

  import { userService } from '../services/user.service.js';
  import { authHeader } from '../services/auth-header.js';

  export default {
    components: {
      InputDefault,
      InlineEditor,
      AlertBar,
      Loader,
      MainNav,
      SectionBlock,
      ItemAdder,
      PageAdder,
      MainFooter,
      Modal,
      Home,
      UploadModal
    },
    created(){
    },
    props:{
      websiteid: {
        type: String
      },
      base: {
        type: String
      },
      readonly: {
        type: Boolean
      },
      creatorhome: {
        type: Boolean
      },
      creatoreditor: {
        type: Boolean
      }
    },
    data: function (){
      return {
        msgtext: '',
        msgclass: 'error',
        username: '',
        password: '',
        editid: '',
        submitted: false,
        loading: false,
        loggingin: false,
        showModal: false,
        editModal: false,
        returnUrl: '',
        error: '',
        pages: {},
        mainpage: '',
        pageslug: this.$route.params.pageslug,
        mainpageid: 'home',
        pagetitle: '',
        nav: '',
        sitedata: {},
        uploadedDoc: '',
        imageroot: process.env.VUE_APP_ROOT_API + '/',
      }
    },
    computed: {
      orderedPages: function () {
        return _.orderBy(this.pages, 'order', 'desc')
      }
    },
    methods: {
        editMenu(pageid){
          this.editid = pageid;
          this.editModal = true;
        },
        uploadDoc(image, id){
            this.uploadedDoc = this.imageroot+image.split("uploads/").pop()

            const requestOptions = {
              headers: authHeader()
            }

            const data = {
              websiteid: this.$route.params.websiteid,
              pageid: id,
              dbentry: 'blockimage',
              content: this.uploadedDoc
            }

            axios.patch(process.env.VUE_APP_ROOT_API+'/pages/', data, requestOptions)
            .then(response => {
                this.getPages()
            })
        },
        toggleReadOnly(){
          this.readonly = !this.readonly
        },
        getMainPage(pageslug){
          axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/pageslug/'+this.pageslug)
            .then(response => {
                this.mainpage = response.data.response
                this.mainpageid = response.data.response._id
                this.pagetitle = response.data.response.pagetitle
                this.getPages()
            })
        },
        getSiteData(){
            console.log('getting')
            axios.get(process.env.VUE_APP_ROOT_API+'/settings/'+this.websiteid)
            .then(response => {
                this.sitedata = response.data.response

                if(JSON.parse(localStorage.getItem('user')).userId == this.sitedata.belongsto){
                  this.readonly = false;
                }
            })
        },
        getPages(){
            const pageid = ''

            if(this.$route.params.pageslug){
              //get pageid first
              this.pageid = this.mainpageid
            } else {
              this.pageid = 'home'
            }

            axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+this.pageid)
            .then(response => {
                this.pages = response.data.response
            })
        },
        getNav(){
            axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/home')
            .then(response => {
                this.nav = response.data.response
            })
        },
        removePage(id){
            const requestOptions = {
                headers: authHeader()
            }

            axios.delete(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/pageid/'+id, requestOptions)
            .then(response => {
                this.showModal = false
                window.location.href = '/creator/'+this.websiteid;
            })
        },
        removeBlock(id){

            const requestOptions = {
              headers: authHeader()
            }

            axios.delete(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+id, requestOptions)
            .then(response => {
                this.showModal = false
                this.getPages()
            })
        }
    },
    mounted(){
        if(this.$route.params.pageslug){
          // is a page
          this.getMainPage(this.$route.params.pageslug)
        } else {
          // is a homepage
          this.getPages()
        }
        this.getSiteData()
        this.getNav()
    }
  }
</script>

<style>
</style>
